import React from "react";
import { Flex, Loader } from "@fluentui/react-northstar";
import { useQuery } from "react-query";

import Card from "../../../Cards";
import IdentityDocuments from "../../../Cards/CardIdentity/IdentityDocuments";
import { QUERY_KEY } from "../../../../constants";
import { _api_get_identity } from "../../../../api";
import { useEmployeeFolderIdUser } from "../../../../store";
import CardInformationPersonnal from "../../../Cards/CardIdentity/features/CardInformationPersonnal";
import CardInformationContact from "../../../Cards/CardIdentity/features/CardInformationContact";
import CardInformationCivilStatus from "../../../Cards/CardIdentity/features/CardInformationCivilStatus";
import CardSurroundingPeople from "../../../Cards/CardIdentity/features/CardSurroundingPeople";
import styled from "styled-components";
import { DEVICE } from "../../../../../../constants/responsive";

const TabIdentity = () => {
    const id_employee = useEmployeeFolderIdUser();

    const { data: identity_data, isLoading: is_loading_identity } = useQuery(
        [QUERY_KEY + "::identity"],
        () => _api_get_identity(id_employee),
        {
            refetchOnWindowFocus: false,
        }
    );

    if (is_loading_identity) {
        return <Loader content="chargement des informations" />;
    }

    return (
        <FlexContainerIdentity>
            <Section column>
                {/* CARD INFORMATION PERSONNAL */}
                <CardInformationPersonnal identity_data={identity_data} />
                {/* INFORMATION DE CONTACT */}
                <CardInformationContact identity_data={identity_data} />
            </Section>
            <Section column>
                <CardInformationCivilStatus identity_data={identity_data} />
            </Section>
            <Section column>
                {/* ENTOURAGE */}
                <CardSurroundingPeople identity_data={identity_data} />
                {/* DOCUMENTS IDENTITY */}
                <Card column>
                    {/* document */}
                    <Card.Body
                        content={
                            <IdentityDocuments
                                identity_documents={
                                    identity_data?.identity_documents
                                }
                            />
                        }
                    />
                </Card>
            </Section>
        </FlexContainerIdentity>
    );
};

export default TabIdentity;

export const Section = styled(Flex)`
    @media ${DEVICE.mobileS} {
        height: fit-content;
        gap: 32px;
        width: 100%;
    }
    @media ${DEVICE.mobileM} {
    }
    @media ${DEVICE.mobileL} {
    }
    @media ${DEVICE.tablet} {
        flex-direction: row;
        flex-wrap: wrap;
    }
    @media ${DEVICE.laptop} {
        gap: 8px;
        max-width: 440px;
    }
    @media ${DEVICE.laptopL} {
        gap: 32px;
    }
    @media ${DEVICE.desktop} {
    }
`;

const FlexContainerIdentity = styled(Flex)`
    @media ${DEVICE.mobileS} {
        justify-content: center;
        flex-wrap: wrap;
        gap: 32px;
        width: 100%;
        padding-inline: 16px;
    }
    @media ${DEVICE.mobileM} {
    }
    @media ${DEVICE.mobileL} {
    }
    @media ${DEVICE.tablet} {
    }
    @media ${DEVICE.laptop} {
        justify-content: space-between;
        flex-wrap: nowrap;
        width: 100%;
        gap: 8px;
    }
    @media ${DEVICE.laptopL} {
        gap: 32px;
    }
    @media ${DEVICE.desktop} {
    }
`;
